import { CustomerTargeting } from "modules/customers/components/Detail/CustomerTargeting"
import { NPSBadge } from "modules/shared/components/Miscelanea/NPSBadge"
import { SentimentBadge } from "modules/shared/components/Miscelanea/SentimentBadge"
import { useTranslation } from "react-i18next"
import { CustomerResponseDataSchema } from "schema"
import { z } from "zod"

type Props = {
  customer: z.infer<typeof CustomerResponseDataSchema>
  customerSentiment?: number | null
}

export const CustomerInfo = ({ customer, customerSentiment }: Props) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col w-full gap-2">
      <div className="flex sm:flex-row flex-col sm:gap-8 gap-2 [&>*]:min-w-52">
        <div className="flex flex-col gap-2">
          <span className="text-base font-medium text-muted-foreground">
            {t("conversations.chat.customer.generalInfo")}
          </span>
          <CustomerTargeting country={customer.country} />
        </div>
        <div className="flex flex-col gap-2 items-start">
          <span className="text-base font-medium text-muted-foreground">
            {t("conversations.chat.customer.sentiment")}
          </span>
          <SentimentBadge sentiment={customerSentiment} />
        </div>
        <div className="flex flex-col gap-2 items-start">
          <span className="text-base font-medium text-muted-foreground">
            {t("conversations.chat.customer.nps")}
          </span>
          <NPSBadge nps={customer.latestNps} />
        </div>
      </div>
    </div>
  )
}
